import { Stack } from "@mui/material";

import { FileBlock, FileIcon } from "@/components";

interface AttachmentDisplayProps {
  name: string;
}

export function AttachmentDisplay({ name }: AttachmentDisplayProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <FileIcon name={name} fontSize={22} />
      <FileBlock name={name} />
    </Stack>
  );
}
